var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import platform from 'platform';
import UserAgentHelper from './UserAgentHelper';
import VersionHelper from './VersionHelper';
var ANDROID_LOW_VERSION = '9';
var IOS_LOW_VERSION = '11';
var EnvChecker = /** @class */ (function (_super) {
    __extends(EnvChecker, _super);
    function EnvChecker() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    EnvChecker.init = function (params) {
        var _b, _c;
        this.data = params !== null && params !== void 0 ? params : {
            os: ((_b = this.env.os) === null || _b === void 0 ? void 0 : _b.family) || '',
            osVersion: ((_c = this.env.os) === null || _c === void 0 ? void 0 : _c.version) || '',
        };
    };
    EnvChecker.isDev = function () {
        return process.env.NEXT_PUBLIC_MODE === 'DEV';
    };
    EnvChecker.isProd = function () {
        return process.env.NEXT_PUBLIC_MODE !== 'QA' && process.env.NEXT_PUBLIC_MODE !== 'DEV';
    };
    EnvChecker.isAndroid = function () {
        return /android/i.test(this.getUserAgent());
    };
    EnvChecker.isApp = function () {
        return /VRBT_APP|VRBT_IOS_APP/i.test(this.getUserAgent());
    };
    EnvChecker.isMobile = function () {
        return this.isApp() || /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(this.getUserAgent());
    };
    EnvChecker.isIOSApp = function () {
        return /VRBT_IOS_APP/i.test(this.getUserAgent());
    };
    EnvChecker.isLowVersion = function () {
        var _b, _c;
        if (this.isApp()) {
            return Number(this.getOSVersion()) <= 28;
        }
        var version = (_c = (_b = this.env.os) === null || _b === void 0 ? void 0 : _b.version) !== null && _c !== void 0 ? _c : '1';
        return VersionHelper.isLower(version, this.isAndroid() ? ANDROID_LOW_VERSION : IOS_LOW_VERSION);
    };
    EnvChecker.isIOS = function () {
        var _b, _c, _d;
        return /iOS|iPhone|iPad/i.test(((_b = this.data) === null || _b === void 0 ? void 0 : _b.os) || ((_d = (_c = this.env) === null || _c === void 0 ? void 0 : _c.os) === null || _d === void 0 ? void 0 : _d.family) || '');
    };
    EnvChecker.getOS = function () {
        if (this.isApp() || this.isAndroid()) {
            return 'AOS';
        }
        if (this.isIOS()) {
            return 'IOS';
        }
        return 'ETC';
    };
    EnvChecker.getOSVersion = function () {
        var _b, _c;
        return ((_b = this.data) === null || _b === void 0 ? void 0 : _b.osVersion) || ((_c = this.env.os) === null || _c === void 0 ? void 0 : _c.version) || '';
    };
    EnvChecker.getAppVersion = function () {
        var _b;
        return ((_b = this.data) === null || _b === void 0 ? void 0 : _b.appVersion) || '';
    };
    EnvChecker.getAppVersionDigit = function () {
        return parseInt(this.getAppVersion().replace(/\./gi, ''), 10);
    };
    EnvChecker.getFcmToken = function () {
        return this.data.firebaseToken || '';
    };
    EnvChecker.getDeviceInfo = function () {
        if (!this.data) {
            return {};
        }
        var _b = this.data, deviceId = _b.deviceId, deviceModel = _b.deviceModel, appVersion = _b.appVersion;
        return { deviceId: deviceId, deviceModel: deviceModel, appVersion: appVersion };
    };
    EnvChecker.isSamsungBrowser = function () {
        return /SamsungBrowser/i.test(this.getUserAgent());
    };
    var _a;
    _a = EnvChecker;
    EnvChecker.env = platform.parse(_a.getUserAgent());
    EnvChecker.getIncmType = function () {
        return _a.isApp() ? 'APP' : 'MWEB';
    };
    return EnvChecker;
}(UserAgentHelper));
export default EnvChecker;
